/**
 * 统计
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import "./index.less";
import IconFont from "@components/IconFont/index";
import dayjs from "dayjs";
class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let {model} = this.props;
        let list = [
            {
                iconName: "icon-jiagoushangpinshu",
                name: __getServerLanguage("JiaGouShangPinShu"),
                num: model.countAll,
            },
            {
                iconName: "icon-kexiadanshangpinshu",
                name: __getServerLanguage("KeXiaDanShangPinShu"),
                num: model.countConfirm,
            },
            {
                iconName: "icon-tianjiashijian",
                name: __getServerLanguage("ZuiJinJiaGouShiJian"),
                num: model.lastTime
                    ? dayjs(model.lastTime).format("YYYY-MM-DD")
                    : "-",
            },
        ];
        return (
            <div>
                <ul className="statistics-wrap">
                    {list.map(function (item, index) {
                        return (
                            <li key={index} style={{flex: '0 0 33%'}}>
                                <IconFont
                                    type={item.iconName}
                                    className="img"
                                ></IconFont>
                                <div>
                                    <p className="statistics-title">
                                        {item.name}
                                    </p>
                                    <p className="num">{item.num || "0"}</p>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

Statistics.defaultProps = {
    model: {},
};

Statistics.propTypes = {};
export default Statistics;
